var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileAppGalleryLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.498 0H4.502C1.197 0 0 1.214 0 4.502v6.996C0 14.803 1.214 16 4.502 16h6.996C14.803 16 16 14.786 16 11.498V4.502C16.017 1.214 14.803 0 11.498 0z",
    fill: "#5F787E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.17 8.008h.421v2.09H3.17v-.842h-.961v.843h-.422v-2.09h.422v.842h.96v-.843zm2.394 1.197c0 .338-.169.523-.472.523-.304 0-.472-.185-.472-.54v-1.18h-.422v1.197c0 .59.32.928.894.928.573 0 .91-.338.91-.945v-1.18h-.421v1.197h-.017zm4.906.236l-.472-1.433h-.354l-.472 1.433-.456-1.433h-.455l.725 2.09h.354l.472-1.382.472 1.383h.354l.726-2.09h-.439L10.47 9.44zm1.669-.236h.776v-.387h-.776v-.422h1.13v-.388h-1.535v2.09h1.585v-.387h-1.163v-.506h-.017zm1.67.894h.42v-2.09h-.42v2.09zm-6.98-.438l-.186.438h-.439l.91-2.09h.372l.91 2.09h-.438l-.186-.438h-.944zm.15-.371h.642l-.32-.742-.321.742zM8.008 5.345A2.67 2.67 0 015.345 2.68h.37a2.295 2.295 0 002.293 2.293 2.295 2.295 0 002.293-2.293h.371a2.67 2.67 0 01-2.664 2.664z"
  }))));
}
export default SvgMobileAppGalleryLogo;